// FAQ answers in the locale files mark emphasis as **bold**
const bold = /\*\*(.+?)\*\*/gs

/** Splits on the capture group, so the bold runs land at the odd indexes. */
export const splitBold = (text: string) => text.split(bold)

/** Drops the markers for consumers that take plain text, such as JSON-LD. */
export const stripBold = (text: string) => text.replace(bold, '$1')
